import BreadCrumb from "../components/BreadCrumb/breadCrumb";
import ContactUs from "../components/contactus";

export default function ContactUsPage(){
    return (
        <>
            <BreadCrumb/>
            <ContactUs/>
        </>
    )
}